const PRODUCT_PRICE_MULTIPLE_OF = 0.01;
function getProductPrice(product) {
  return product?.fixedPriceOptions?.price || "0";
}
export {
  PRODUCT_PRICE_MULTIPLE_OF,
  getProductPrice
};
//# sourceMappingURL=product-price.js.map
